import { render, staticRenderFns } from "./commissonsDetail.vue?vue&type=template&id=0e63f98e&scoped=true&"
import script from "./commissonsDetail.vue?vue&type=script&lang=js&"
export * from "./commissonsDetail.vue?vue&type=script&lang=js&"
import style0 from "./commissonsDetail.vue?vue&type=style&index=0&id=0e63f98e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63f98e",
  null
  
)

export default component.exports